<div class="flex items-center">
  <div class="text-base font-medium mr-2">
    {{ name }}
  </div>

  <p-avatar
    [style]="{ 'background-color': 'black', color: 'white' }"
    label="{{ name | iniciaisNome }}"
    shape="circle"
    size="large"
    styleClass="mr-3 ml-2"
  />
</div>
